import { render, staticRenderFns } from "./VariableCompensation.vue?vue&type=template&id=4c3b3dd9&scoped=true"
import script from "./VariableCompensation.vue?vue&type=script&lang=js"
export * from "./VariableCompensation.vue?vue&type=script&lang=js"
import style0 from "./VariableCompensation.vue?vue&type=style&index=0&id=4c3b3dd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3b3dd9",
  null
  
)

export default component.exports